<template>
  <div :class="['input-group',{ 'icon-valid': (valid && email.length > 0) }, { 'icon-error': (!valid && email.length > 0) }]" >
    <input
      id="email"
      name="email"
      v-model="email"
      class="base-input"
      type="mail"
      autocomplete="off"
      placeholder="exemplo@mail.com"
      @input="$emit('input', email)"
      @blur="enviaGA()"
    >
  </div>
</template>
<script>


export default {
  data() {
    return {
      email: '',
      validacoes: {
        email: false
      }
    }
  },
  props: {
    valid: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    enviaGA() {
      if(this.valid) {
        const pathLocation = window.location.pathname.replaceAll("/", "")
        dataLayer.push({
          event: 'customEvent',
          eventCategory: `blog: ${pathLocation}`,
          eventAction: 'preencheu:calculadora-custo-cnpj',
          eventLabel: `email`
        })
      }
    },
  },


}
</script>
<style lang="scss" src="./style.scss" scoped></style>
